import crypto from 'crypto';


// Decrypt the encrypted string back to JSON
export function decryptJson(encryptedData: string, secretKey: string): object {
    const algorithm = 'aes-256-cbc'; // AES encryption algorithm
    const ivLength = 16; // AES requires a 16-byte IV

    const [ivHex, encryptedText] = encryptedData.split('@:_-');

    const iv = Buffer.from(ivHex, 'hex');

    const decipher = crypto.createDecipheriv(algorithm, Buffer.from(secretKey, 'utf-8'), iv);

    let decryptedData = decipher.update(encryptedText, 'hex', 'utf-8');

    decryptedData += decipher.final('utf-8');

    return JSON.parse(decryptedData);
}
